<template>
  <div class="col">
    <v-row align="center" justify="center" class="my-5">
      <v-img :src="require('@assets/logo/Logo_SemFundo_Agrosim_reduzido.png')" alt="AgroSim" max-width="300" class=""
        contain />
    </v-row>

    <v-row align="center" justify="center">
      <div>
        <h1>
          Política de Privacidade
        </h1>
      </div>
    </v-row>

    <v-row align="center" justify="center" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>

          1 - Definições
        </h3>

        Para fins desta Política de Privacidade, aplicam-se as seguintes definições:</br>
        <ul>
          <li>
            Cookies: Arquivos enviados pelo servidor do Portal para o computador dos Visitantes, com a finalidade de
            identificar o computador e obter dados de acesso, como páginas navegadas ou links clicados, permitindo,
            desta forma, personalizar a navegação dos Visitantes no Portal, de acordo com o seu perfil.
          </li>
          <li>
            AgroSim: Denominação utilizada neste documento para identificar a controladora e proprietária deste
            Portal;

          </li>
          <li>

            AgroSim representada pela DENUTRI AGRONEGÓCIOS EIRELI, inscrita sob o nº 05.627.132.0001-61, com sede na
            cidade de Dois Irmãos - RS, Av. Rua Sede Campestre.
          </li>

          <li>
            IP: Abreviatura de Internet Protocol. É um conjunto de números que identifica o computador dos Visitantes na
            Internet.
          </li>

          <li>

            Logs: Registros de atividades dos Visitantes efetuadas no Portal.
          </li>

          <li>

            Portal: Designa o endereço eletrônico http://www.agrosim.com.br e seus subdomínios.
          </li>
          <li>

            Visitante: Qualquer pessoa que navegar pelo Portal.
          </li>

          <li>

            Usuário: Visitantes que estiverem autenticados no sistema do Portal.
          </li>

          <li>
            Web beacons: Linhas de programação em páginas HTML que tem como finalidade obter detalhes da navegação do
            usuário, a exemplo de quanto tempo ficou com o site aberto, qual endereço visitado em seguida, dentre
            outros.
          </li>
        </ul>
      </div>
    </v-row>

    <v-row align="left" justify="left" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>2 - Obtenção dos dados e informações</h3>
        <ul>
          <li>

            2.1 - Os dados e informações serão obtidos quando os Visitantes interagirem com as diversas funcionalidades
            existentes no Portal, fornecendo as informações voluntariamente, como na seção de “Contato” por exemplo.
          </li>
        </ul>
      </div>
    </v-row>

    <v-row align="center" justify="center" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>

          3 - Armazenamento dos Dados e Informações
        </h3>
        <ul>
          <li>

            3.1 - Todos os dados e informações coletados dos Visitantes serão incorporados ao banco de dados do Portal,
            sendo sua responsável a AgroSim.
          </li>
          <li>

            3.2 - Os dados e informações coletados estarão armazenados em ambiente seguro, observado o estado da técnica
            disponível, e somente poderão ser acessadas por pessoas qualificadas e autorizadas pela AgroSim.
          </li>
          <li>

            3.3 - Considerando que nenhum sistema de segurança é absolutamente seguro, a AgroSim se exime de
            quaisquer
            responsabilidades por eventuais danos e/ou prejuízos decorrentes de falhas, vírus ou invasões do banco de
            dados
            do Portal, salvo nos casos de dolo ou culpa pela mesma.
          </li>
          <li>

            3.4 - A AgroSim coleta somente as informações indispensáveis à viabilização de seu negócio, qual seja,
            gerenciamento de dados de propriedades rurais.
          </li>

        </ul>
      </div>
    </v-row>

    <v-row align="center" justify="center" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>

          4 - Uso dos Dados e Informações
        </h3>

        <ul>
          <li>
            4.1 - Os dados e informações coletados dos Visitantes poderão ser utilizados para as seguintes finalidades:
            <ul>
              <li>

                a) Responder a eventuais dúvidas e solicitações dos Visitantes;
              </li>
              <li>

                b) Cumprimento de ordem legal ou judicial;
              </li>
              <li>

                c) Constituir, defender ou exercer regularmente direitos em âmbito judicial ou administrativo;
              </li>
              <li>

                d) Elaborar estatísticas gerais, para identificação do perfil dos Visitantes e desenvolvimento de
                campanhas da
                AgroSim, mas sem realizar identificação pessoal;
              </li>
              <li>

                e) Garantir a segurança dos Visitantes;
              </li>
              <li>

                f) Manter atualizados os cadastros dos Visitantes para fins de contato por telefone, correio eletrônico,
                SMS,
                mala direta ou por outros meios de comunicação;
              </li>
              <li>

                g) Informar a respeito de novidades, promoções e eventos da AgroSim e de seus parceiros comerciais.
              </li>
            </ul>
          </li>

          <li>

            4.2 - A base de dados coletados pelo Portal AgroSim não será compartilhada, vendida, cedida,
            transferida,
            informada ou alugada a terceiros.
          </li>
          <li>

            4.3 - Os dados adquiridos somente poderão ser acessados por profissionais devidamente autorizados pela
            AgroSim, respeitando a necessidade a que serão submetidos, a relevância para os objetivos do Portal e aos
            interesses dos usuários, além de preservar a privacidade dos usuários.
          </li>
          <li>

            4.4 - Caso o Usuário deixe de utilizar os serviços oferecidos pelo Portal, a AgroSim poderá, para fins
            de
            auditoria e preservação de direitos, permanecer com o registro de seus dados e informações, pelo período
            máximo
            de 5 (cinco) anos, com a faculdade de excluí-los definitivamente segundo sua conveniência.
          </li>
        </ul>

      </div>
    </v-row>

    <v-row align="center" justify="center" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>

          5 - Cookies
        </h3>

        <ul>
          <li>

            5.1 - O Portal poderá fazer o uso de cookies, cabendo aos Visitantes configurarem o seu navegador de
            Internet,
            caso deseje bloqueá-los. Nesta hipótese, algumas funcionalidades do Portal poderão ser limitadas.
          </li>
          <li>

            5.2. Também, o Portal poderá utilizar web beacons para coletar dados de comportamento dos visitantes das
            páginas, onde a instalação de arquivos nos equipamentos dos visitantes não é necessária.
          </li>
          <li>

            5.3. Outras tecnologias poderão ser utilizadas para a obtenção de dados de navegação pelo usuário, no
            entanto,
            respeitarão sempre aos termos desta política e as opções do usuário a respeito de sua coleta e
            armazenamento.
          </li>

        </ul>
      </div>
    </v-row>

  </br>

    <v-row align="center" justify="center" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>

          6 - Disposições Gerais
        </h3>
        <ul>
          <li>

            6.1 - As disposições constantes desta Política de Privacidade poderão ser atualizadas ou modificadas a
            qualquer
            momento, cabendo aos Visitantes verificá-la sempre que efetuar o acesso ao Portal.

          </li>
          <li>

            6.2 - Os Visitantes deverão entrar em contato em caso de qualquer dúvida com relação às disposições
            constantes
            desta Política de Privacidade através da Seção de “Contato”.
          </li>
        </ul>
      </div>
    </v-row>

    <v-row align="center" justify="center" style="margin-left: 10%; margin-right: 10%; padding: 5px;">
      <div>
        <h3>

          7 - Lei Aplicável e Jurisdição
        </h3>
        <ul>
          <li>

            7.1 - A presente Política de Privacidade será interpretada segundo a legislação brasileira, no idioma
            português,
            sendo eleito o Foro da Comarca de Dois Irmãos no estado do Rio Grande do Sul para dirimir qualquer litígio,
            questão
            ou dúvida superveniente, com expressa renúncia de qualquer outro, por mais privilegiado que seja.
          </li>
        </ul>
      </div>
    </v-row>

  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  },
}

</script>

<style scoped></style>
